import { Checkbox } from '@mui/material';
import styled from 'styled-components';

export const StyledCustomCheckbox = styled(Checkbox)`
  color: ${({ theme }) => theme.palette.primary.main};

  &.Mui-checked {
    color: ${({ theme }) => theme.palette.primary.main};

    .MuiIconButton-label {
      &:after {
        content: '';
        background-color: ${({ theme }) => theme.palette.primary.main};
        width: 18px;
        height: 18px;
        position: absolute;
        top: 50%;
        left: 50%;
        border-radius: 2px;
        transform: translate(-50%, -50%);
      }
    }
  }
`;
